import {inject, Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly snackBar = inject(MatSnackBar);

  showMessage(message: string, durationMs = 8000): void {
    if (!message.trim()) return;
    this.snackBar.open(message, 'Close', {
      duration: durationMs, horizontalPosition: 'center', verticalPosition: 'top',
      panelClass: ['app-toast'],
    });
  }

  showError(message: string, durationMs = 5000): void {
    if (!message.trim()) {
      return;
    }

    this.snackBar.open(message, 'Close', {
      duration: durationMs,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['app-toast', 'app-toast-error'],
    });
  }
}
